export default "__VITE_ASSET__BpNB3NJ1__"